import { useAuth as useAuthContext2 } from 'src/shared/auth/AuthContext';

export const useAuth = useAuthContext2;

export default useAuth;
